import connection from "@shared/utils/connection";

export async function listadoNotificaciones() {
    try {
        return await connection({
            method: "GET",
            url: `/api/backend/notificaciones`,
        });
    } catch (err) {
        return { estado: 0, data: [] };
    }
}

export async function updateNotification(id) {
    try {
        return await connection({
            method: "PUT",
            url: `/api/backend/notificaciones/${id}`,
            body: { leido: true }
        });
    } catch (err) {
        console.error("Error al actualizar notificación:", err);
        throw new Error("No se pudo actualizar la notificación");
    }
}

export async function eliminarNotificacion(id) {
    try {
        return await connection({
            method: "DELETE",
            url: `/api/backend/notificaciones/${id}`
        });
    } catch (err) {
        console.error("Error al eliminar notificación:", err);
        throw new Error("No se pudo eliminar la notificación");
    }
}
